import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

export const NavigationWrapper = styled.div<{ $isPrePTO: boolean }>`
  ${({ theme, $isPrePTO }) => css`
    display: flex;
    align-items: ${$isPrePTO ? 'left' : 'center'};
    height: 52px;
    background: ${theme.colors.cardElevationMidWhite};
    box-shadow: ${theme.elevations.midInverse};

    @media screen and (min-width: ${theme.breakpoints.small}) {
      height: 74px;
      width: 100%;
    }

    @media screen and (min-width: ${$isPrePTO
        ? theme.breakpoints.small
        : theme.breakpoints.medium}) {
      flex-direction: column;
      padding: ${$isPrePTO ? '0 14px 0 12px' : '0 42px 0 32px'};
      width: calc(100% + 10px);
      background: ${theme.colors.backgroundSecondaryGrey05};
      box-shadow: unset;
      height: 100%;
    }

    @media screen and (min-width: ${theme.breakpoints.large}) {
      padding: 0 42px 0 ${$isPrePTO ? '48px' : '32px'};
    }
  `}
`;

export const LogoLink = styled(Link)<{ $isPrePTO: boolean }>`
  ${({ theme, $isPrePTO }) => `
    width: 156px;
    height: auto;

    margin-top: 52px;
    margin-bottom: ${$isPrePTO ? '64px' : '88px'};

    @media screen and (max-width: ${$isPrePTO ? theme.breakpoints.small : theme.breakpoints.medium}) {
      display: none;
    }

    @media screen and (max-width: ${theme.breakpoints.large}) {
      margin-top: 44px;
      margin-bottom: ${$isPrePTO ? '64px' : '80px'};
    }
  `}
`;

export const MenuItems = styled.div`
  display: flex;
  flex-direction: column;

  button {
    justify-content: flex-start;
    margin-bottom: 32px;
  }

  @media screen and (max-width: ${({ theme }) => theme.breakpoints.medium}) {
    width: 100%;
    flex-direction: row;
    justify-content: space-around;
    button {
      flex-direction: column;
      height: fit-content;
      margin-bottom: 0;
      div {
        margin: 0;
      }
    }
  }
`;
